import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { DocumentCodes } from '../../../../core/enums';
import { GlobalModalsService, NotificationService } from '../../../../core/services';
import { StoragePlaceFinderModalComponent } from '../../../stores/storage-place-finder-modal/storage-place-finder-modal.component';
import { DeliveryNoteProcessModalComponent } from '../../../orders/delivery-note-process-modal/delivery-note-process-modal.component';
import { ProcessModalComponent } from '../../../production-orders/process-modal/process-modal.component';
import { AddEditOrderModalComponent } from '../../../bulk-containers/orders/add-edit-order-modal/add-edit-order-modal.component';
import { StockTransferProcessModalComponent } from '../../../stock-transfer/stock-transfer-process-modal/stock-transfer-process-modal.component';
import { FlourService } from '../../../bulk-containers/core/services';
import { IFlourPackingListItem } from '../../../flour/core/interfaces';
import {
  VoucherCodeDetailsModalComponent
} from '../../../vouchers/views/modals/voucher-code-details-modal/voucher-code-details-modal.component';
import { SearchComponent } from '../../../../ui/search/search.component';
import { VouchersUtils } from '../../../vouchers/core/utils/VouchersUtils';
import { UNKNOWN_BARCODE_MESSAGE } from '../../../../core/utils';

@Component({
    selector: 'app-scanner-chart',
    templateUrl: './scanner-chart.component.html',
    styleUrl: './scanner-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScannerChartComponent {

  @ViewChild('storagePlaceFinderModalComponent') storagePlaceFinderModalComponent: StoragePlaceFinderModalComponent;
  @ViewChild('deliveryNoteProcessModalComponent') deliveryNoteProcessModalComponent: DeliveryNoteProcessModalComponent;
  @ViewChild('processModalComponent') processModalComponent: ProcessModalComponent;
  @ViewChild('addEditOrderModalComponent') addEditOrderModalComponent: AddEditOrderModalComponent;
  @ViewChild('stockTransferProcessModal') stockTransferProcessModal: StockTransferProcessModalComponent;
  @ViewChild(VoucherCodeDetailsModalComponent) voucherCodeDetailsModalComponent: VoucherCodeDetailsModalComponent;
  @ViewChild('voucherSearch') voucherSearchComponent: SearchComponent;

  private readonly _notificationService = inject(NotificationService);
  private readonly _globalModalService = inject(GlobalModalsService);
  private readonly _flourService = inject(FlourService) as FlourService<IFlourPackingListItem>;

  public scanVoucher(val: string): void {
    const { valid, code } = VouchersUtils.isValidCode(val);

    if (valid) {
      this.voucherCodeDetailsModalComponent.showModal({ code });
      this.voucherSearchComponent.clearValue();
    } else {
      this._notificationService.pushError('Fehler', 'Gutscheincode ungültig.');
    }
  }

  public searchChanged(val: string): void {
    const prefix = val.slice(0, 2);

    if (prefix === DocumentCodes.ORDER) {
      this.addEditOrderModalComponent.showModal({ id: parseInt(val.slice(2), 10) } as any);
    } else if (prefix === DocumentCodes.PRODUCTION_ORDER) {
      this.openModal('productionOrderProcessModal');
      this.processModalComponent.orderNumber = val.slice(2);
      setTimeout(() => this.processModalComponent.handleNumberScan(val.slice(2)));
    } else if (prefix === DocumentCodes.DELIVERY_NOTE) {
      this.openModal('deliveryNoteProcessModal');
      this.deliveryNoteProcessModalComponent.orderNumber = val;
      this.deliveryNoteProcessModalComponent.handleNumberScan(val);
    } else if (val.length === 13) {
      this.openStoragePlaceFinderModal(val);
    } else if (prefix === DocumentCodes.STOCK_TRANSFER) {
      this._flourService.getPackingListById(+val.slice(2)).subscribe(res => {
        setTimeout(() => {
          const type = res.isOutgoingDoc ? 1 : 0;
          this.openModal('stockTransferProcessModal', { type });
          this.stockTransferProcessModal.transferNumber = val.slice(2);
          setTimeout(() => this.stockTransferProcessModal.handleNumberScan(val.slice(2) + '\n'));
        });
      }, () => this._notificationService.pushError('Fehler', 'Fehler beim Abrufen der Packliste.'));
    } else {
      this._notificationService.pushError('Fehler', UNKNOWN_BARCODE_MESSAGE);
    }
  }

  private openStoragePlaceFinderModal(val: string): void {
    this.storagePlaceFinderModalComponent.showModal({ isMobile: false });
    this.storagePlaceFinderModalComponent.eanCode = val;
    this.storagePlaceFinderModalComponent.handleNumberScan();
  }

  private openModal(key: string, param: any = null): void {
    this._globalModalService.openModal(key, param);
  }
}

